import React from "react";
import { Col, Row, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";

export default function AllFamilyFilter() {
  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"Filters"}</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"home"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"Data Filter"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{"Filters"}</li>
              </ul>
            </div>
          </div>
        </Col>
        {/* Filter by Entry Date */}
        <Col xl={6}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"Filter by Entry Date"}</h3>
            </div>
            <form>
              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>From</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>To</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>
              <Button style={{ marginTop: "30px" }} variant="success">
                {" "}
                Search
              </Button>
            </form>
          </div>
        </Col>
        {/* Filter by Rescued Date */}
        <Col xl={6}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                {"Filter by Rescued Date"}
              </h3>
            </div>
            <form>
              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>From</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>To</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>
              <Button style={{ marginTop: "30px" }} variant="success">
                {" "}
                Search
              </Button>
            </form>
          </div>
        </Col>
        {/* Filter by Flagged */}
        <Col xl={6}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"Filter by Flagged"}</h3>
            </div>
            <form>
              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>Flagged</Form.Label>
                <Form.Select>
                  <option>Select...</option>
                  <option>Yes</option>
                  <option>No</option>
                </Form.Select>
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>From</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>To</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>
              <Button style={{ marginTop: "30px" }} variant="success">
                {" "}
                Search
              </Button>
            </form>
          </div>
        </Col>
        {/* Filter by Province */}
        <Col xl={6}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"Filter by Province"}</h3>
            </div>
            <form>
              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>Province</Form.Label>
                <Form.Select>
                  <option>Select...</option>
                  <option>Khyber Pkhtunkhuwa</option>
                  <option>Sindh</option>
                  <option>Balochistan</option>
                  <option>Punjab</option>
                  <option>Gilgit</option>
                </Form.Select>
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>From</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>To</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>
              <Button style={{ marginTop: "30px" }} variant="success">
                {" "}
                Search
              </Button>
            </form>
          </div>
        </Col>
        {/* Filter Rescued By */}
        <Col xl={6}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"Filter Rescued By"}</h3>
            </div>
            <form>
              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>Rescued By</Form.Label>
                <Form.Select>
                  <option>Select...</option>
                  <option>FSF-005</option>
                  <option>FSF-007</option>
                  <option>FSF-009</option>
                </Form.Select>
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>From</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>To</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>
              <Button style={{ marginTop: "30px" }} variant="success">
                {" "}
                Search
              </Button>
            </form>
          </div>
        </Col>
        {/* Filter by Slavery Reason */}
        <Col xl={6}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                {"Filter by Slavery Reason"}
              </h3>
            </div>
            <form>
              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>Slavery Reason</Form.Label>
                <Form.Select>
                  <option>Select...</option>
                  <option>Reason 1</option>
                  <option>Reason 2</option>
                  <option>Reason 3</option>
                </Form.Select>
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>From</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>To</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>
              <Button style={{ marginTop: "30px" }} variant="success">
                {" "}
                Search
              </Button>
            </form>
          </div>
        </Col>
        {/* Filter by Loan Type */}
        <Col xl={6}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"Filter by Loan Type"}</h3>
            </div>
            <form>
              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>Loan Type</Form.Label>
                <Form.Select>
                  <option>Select...</option>
                  <option>Type 1</option>
                  <option>Type 2</option>
                  <option>Type 3</option>
                </Form.Select>
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>From</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>To</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>
              <Button style={{ marginTop: "30px" }} variant="success">
                {" "}
                Search
              </Button>
            </form>
          </div>
        </Col>
        {/* Filter by Buisness Type */}
        <Col xl={6}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                {"Filter by Buisness Type"}
              </h3>
            </div>
            <form>
              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>Buisness Type</Form.Label>
                <Form.Select>
                  <option>Select...</option>
                  <option>Type 1</option>
                  <option>Type 2</option>
                  <option>Type 3</option>
                </Form.Select>
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>Rescued By</Form.Label>
                <Form.Select>
                  <option>Select...</option>
                  <option>Type 1</option>
                  <option>Type 2</option>
                  <option>Type 3</option>
                </Form.Select>
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>From</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>To</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>
              <Button style={{ marginTop: "30px" }} variant="success">
                {" "}
                Search
              </Button>
            </form>
          </div>
        </Col>
        {/* Filter by City */}
        <Col xl={6}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"Filter by City"}</h3>
            </div>
            <form>
              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>City</Form.Label>
                <Form.Select>
                  <option>Select...</option>
                  <option>City 1</option>
                  <option>City 2</option>
                  <option>City 3</option>
                </Form.Select>
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>From</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>To</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>
              <Button style={{ marginTop: "30px" }} variant="success">
                {" "}
                Search
              </Button>
            </form>
          </div>
        </Col>
        {/* Filter by Follow Up */}
        <Col xl={6}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"Filter by Follow Up"}</h3>
            </div>
            <form>
              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>Follow Up</Form.Label>
                <Form.Select>
                  <option>Select...</option>
                  <option>Follow Up 1</option>
                  <option>Follow Up 2</option>
                  <option>Follow Up 3</option>
                </Form.Select>
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>From</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>

              <Form.Group style={{ marginTop: "30px" }}>
                <Form.Label>To</Form.Label>
                <Form.Control type="Date" />
              </Form.Group>
              <Button style={{ marginTop: "30px" }} variant="success">
                {" "}
                Search
              </Button>
            </form>
          </div>
        </Col>
      </Row>
    </PageLayout>
  );
}
